import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
} from "@material-ui/core";
import React from "react";
import { RedButton } from "../../components/RedButton";
import { Tag } from "../../entities/customer/Tag";

interface DeleteTagDialogProps {
	open: boolean;
	tag: Tag | null;
	onClose: () => void;
	onConfirm: () => void;
}

export function DeleteTagDialog(props: DeleteTagDialogProps) {
	const { open, tag, onClose, onConfirm } = props;

	return (
		<Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
			<DialogTitle id="alert-dialog-title">Delete Tag?</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					Are you sure you want to delete the tag "{tag?.text}"? This will remove the tag from being able to be assigned again, but will not remove it
					from any customers or tickets it was previously assigned to.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="primary">
					Cancel
				</Button>
				<RedButton onClick={onConfirm} autoFocus>
					Delete
				</RedButton>
			</DialogActions>
		</Dialog>
	);
}
